/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-20 09:42:21
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import axios from "@/axios/axios";
import { message, Pagination, Card, List, Breadcrumb } from "antd";
import Header from "@/components/header/index";
import "./index.less";
import * as actions from "@/store/actions";
import { withRouter, Link } from "react-router-dom";
const NewsList: FC<any> = ({ history, setNews }) => {
  // 教师列表
  const [teacherList, setTeacherList] = useState([] as any);
  const [page, setPage] = useState({
    currentPage: 1,
    totalResultSize: 1,
  });
  const getTeacher = async (currentPage: number) => {
    const { code, data, msg }: any = await axios.post(
      "/main/front/ce/information/list",
      { itemInformation: {}, page: { currentPage: currentPage, pageSize: 8 } }
    );
    if (code === 0) {
      const {
        page: { currentPage, totalResultSize },
        informationList = [],
      } = data;
      let mapArr = [];
      for (let i = 0; i < informationList.length; i += 5) {
        mapArr.push(informationList.slice(i, i + 5));
      }
      setTeacherList(mapArr);
      setPage({
        currentPage,
        totalResultSize,
      });
    } else {
      message.error(msg);
    }
  };
  useEffect(() => {
    getTeacher(1);
  }, []);
  const onChange = (currentPage: any) => {
    setPage({
      ...page,
      currentPage,
    });
    getTeacher(currentPage);
  };
  const toNewsInfo = (item: any) => {
    setNews({ news: item });
    history.push(`/index/news?id=${item.id}`);
  };
  return (
    <div>
      <div className="newsInfo-container">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>继教资讯</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          {teacherList.map((arr: any, index: number) => {
            return (
              <div className="information_border">
                {arr.map((it: any) => (
                  <div
                    className="information-container"
                    onClick={() => {
                      toNewsInfo(it);
                    }}
                  >
                    <p>{it.title}</p>
                    <span>{it.updateTime.split(" ")[0]}</span>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
        }}
      >
        <Pagination
          showSizeChanger={false}
          current={page.currentPage}
          pageSize={8}
          total={page.totalResultSize}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(withRouter(NewsList));
